import React, { useEffect, useState } from "react";
import style from "./Account.module.scss";
import CircularProgress from "../../../../CircularProgress/CircularProgress";

export const ExternalAccountWrapper = ({
  logo,
  onChange,
  onCheckCashAccount,
  selectedAccount,
  selectedCash,
  getAccountsService,
  account,
  currencyISO,
  disabled,
  onChangeAvailableAccounts,
  error,
}) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (account.HolderId && account.AccountId) {
      const getBankAccounts = async () => {
        setLoading(() => true);
        try {
          const { response } = await getAccountsService({
            personId: account.HolderId,
            accountId: account.AccountId,
          });

          setAccounts(() => response.clientBankAccounts || []);
          onChangeAvailableAccounts(response.clientBankAccounts || []);
        } catch (error) {
          console.error("Error getting bank accounts", error);
        } finally {
          setLoading(() => false);
        }
      };
      getBankAccounts();
    }
  }, [account.HolderId, account.AccountId]);


  const handleCheckAccount = (accountNumber) => {
    if (selectedAccount === accountNumber) {
      onChange(null);
    } else {
      onChange(accountNumber);
    }
    if (selectedCash) {
      onCheckCashAccount(); 
    }
  };

  const handleCheckCashAccount = () => {
    if (selectedAccount) {
      onChange(null);
    }
    onCheckCashAccount();
  };

  return (
    accounts.filter((account) => account.currencyISO === currencyISO).length > 0 && (
      <div key="accWrapper" className={`${style.bankAccounts} ${error ? style.error : ""}`}>
        {loading ? (
          <CircularProgress />
        ) : (
          <React.Fragment>
            {accounts
              .filter((account) => account.currencyISO === currencyISO)
              .map((account) => {
                return (
                  <div
                    className={`${style.item} ${selectedAccount === account.number ? style.selected : null} ${
                      disabled ? style.disabled : null
                    }`}
                    key={account.number}
                    onClick={disabled ? () => {} : () => handleCheckAccount(account.number)}
                  >
                    <div className={style.logo}>
                      <img src={`${logo}`} />
                    </div>
                    <div className={style.info}>
                      <span>N° </span>
                      <span className={style.data}>{account.number}</span>
                      <br />
                      <span>Currency </span>
                      <span className={style.data}>{account.currencyISO}</span>
                      <br />
                      <span>Type </span>
                      <span className={style.data}>{account.Type}</span>
                    </div>
                    <div className={style.checkbox}>
                      {selectedAccount === account.number ? (
                        <i className="fa fa-check-square-o" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-square-o" aria-hidden="true" />
                      )}
                    </div>
                  </div>
                );
              })}
            <hr />
            <div
              className={`${style.cash} ${selectedCash ? style.selected : null} ${
                disabled ? style.disabled : null
              }`}
              onClick={disabled ? () => {} : () => handleCheckCashAccount()}
            >
              <div>
                <span>Use local cash account</span>
              </div>
              <div className={style.checkbox}>
                {selectedCash ? (
                  <i className="fa fa-check-square-o" aria-hidden="true" />
                ) : (
                  <i className="fa fa-square-o" aria-hidden="true" />
                )}
              </div>
            </div>
          </React.Fragment>
        )}
        {error && <span className={style.errorText}>{error}</span>}
      </div>
    )
  );
};